<template>
  <div>
    <b-card class="card-custom-class">
      <div class="closemodel">
        <button @click="$bvModal.hide(address._id)" type="button">
          <span><img src="img/address/close.png" alt="" /></span>
        </button>
      </div>
      <b-icon
        class="mr-1"
        icon="geo-alt-fill"
        scale="1.8"
        variant="success"
      ></b-icon>
      <span class="change-location-text ml-2">{{ $t("editAddress") }} </span>
    </b-card>
    <b-card>
      <v-container>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('viewAddress.fullName')"
              >
                <v-text-field
                  v-model="address.fullName"
                  :label="$t('viewAddress.fullName')"
                ></v-text-field>
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Street Address"
                > -->
              <v-text-field
                v-model="address.street1"
                :label="$t('viewAddress.streetAddress')"
              ></v-text-field>
              <!-- <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider> -->
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Building, Company, Apartment"
                > -->
              <v-text-field
                v-model="address.street2"
                :label="$t('viewAddress.building')"
              ></v-text-field>
              <!-- <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider> -->
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="House Number"
                > -->
              <v-text-field
                v-model="address.houseNumber"
                :label="$t('viewAddress.unitNum')"
              ></v-text-field>
              <!-- <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider> -->
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <ValidationProvider
                rules="required|zipcode"
                v-slot="{ errors }"
                :name="$t('viewAddress.zipCode')"
              >
                <v-text-field
                  v-model="address.zip"
                  :label="$t('viewAddress.zipCode')"
                ></v-text-field>
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <ValidationProvider
                rules="required|max:20|min:2"
                v-slot="{ errors }"
                :name="$t('viewAddress.city')"
              >
                <v-text-field
                  v-model="address.city"
                  :label="$t('viewAddress.city')"
                ></v-text-field>
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <ValidationProvider
                rules="required|max:20|min:2"
                v-slot="{ errors }"
                :name="$t('viewAddress.state')"
              >
                <v-text-field
                  v-model="address.state"
                  :label="$t('viewAddress.state')"
                ></v-text-field>
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <ValidationProvider
                rules="required|max:20|min:2"
                v-slot="{ errors }"
                :name="$t('viewAddress.country')"
              >
                <v-text-field
                  v-model="address.country"
                  :label="$t('viewAddress.country')"
                ></v-text-field>
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <ValidationProvider
                rules="required|usPhone"
                v-slot="{ errors }"
                :name="$t('viewAddress.phoneNum')"
              >
                <v-text-field
                  v-model="phone"
                  :label="$t('viewAddress.phoneNum')"
                ></v-text-field>

                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <ValidationProvider
                rules="email"
                v-slot="{ errors }"
                :name="$t('viewAddress.email')"
              >
                <v-text-field
                  v-model="email"
                  :label="$t('viewAddress.email')"
                  :placeholder="$t('viewAddress.email')"
                ></v-text-field>

                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <b-form-select
                v-model="address.category"
                :selected="address.category"
                :placeholder="$t('viewAddress.selectAddressType')"
                :name="$t('viewAddress.addressType')"
                id="Address Type"
                class="form-control"
                size="1"
              >
                <option disabled value="Select an Address Type">
                  {{ $t("viewAddress.selectAddressType") }}
                </option>
                <option value="Home">{{ $t("viewAddress.home") }}</option>
                <option value="Office">{{ $t("viewAddress.office") }}</option>
                <option value="Other">{{ $t("viewAddress.other") }}</option>
              </b-form-select>
            </v-col>
            <v-col
              style="margin-top: 4px; font-size: 19px"
              cols="12"
              sm="6"
              md="6"
            >
              <b-row>
                <b-col md="5">
                  <b-card-text class="price-details">{{
                    $t("viewAddress.defaultAddress")
                  }}</b-card-text>
                </b-col>
                <b-col md="7">
                  <b-form-radio-group
                    v-model="address.isDefault"
                    id="radio-group-2"
                    name="radio-sub-component"
                  >
                    <b-form-radio size="lg" :value="true">Yes</b-form-radio>
                    <b-form-radio size="lg" :value="false">No</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </v-col>

            <b-col class="addAddressBtn">
              <template v-if="!isLoading">
                <button
                  @click="$bvModal.hide(address._id)"
                  type="button"
                  class="btn btn-outline-primary btn-lg mr-3"
                >
                  <span class="button-text"></span>
                  {{ $t("viewAddress.cancel") }}
                </button>
                <p style="display: none">{{ invalid }}</p>
                <button
                  @click="onSubmitAddress"
                  type="button"
                  class="btn btn-primary btn-lg"
                >
                  <span class="button-text"></span>
                  {{ $t("viewAddress.save") }}
                </button>
              </template>
              <template v-if="isLoading">
                <b-spinner
                  v-for="i in 3"
                  :key="i"
                  class="mr-1"
                  small
                  label="Small Spinner"
                  type="grow"
                ></b-spinner>
              </template>
            </b-col>
          </v-row>
        </ValidationObserver>
      </v-container>
    </b-card>
  </div>
</template>
<script>
import {
  extend,
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full.esm";

extend("usPhone", {
  validate(value) {
    const cleaned = value.trim();
    return /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}$/.test(cleaned);
  },
  message: "The {_field_} field must be a valid US phone number",
});

extend("zipcode", {
  validate: (value) => /^\d{5}(-\d{4})?$/.test(value),
  message: "Enter a valid ZIP code (e.g., 12345 or 12345-6789)",
});
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    address: {
      address: () => {},
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      phone: "",
      email: "",
    };
  },
  computed: {
    // phoneNumber() {
    //   return this.address && this.address.contacts
    //     ? this.address.contacts[0].value
    //     : "";
    // },
    // email() {
    //   return this.address && this.address.contacts
    //     ? this.address.contacts[1].value
    //     : "";
    // },
  },
  methods: {
    async onSubmitAddress() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      let payload = {
        fullName: this.address.fullName,
        houseNumber: this.address.houseNumber,
        street2: this.address.street2,
        street1: this.address.street1,
        zip: this.address.zip,
        city: this.address.city,
        state: this.address.state,
        country: this.address.country,
        phoneNumber: this.phone,
        email: this.email,
        category: this.address.category,
        isDefault: this.address.isDefault,
        id: this.address._id,
      };
      await this.$store
        .dispatch("address/editAddress", payload)
        .then(() => {
          this.isLoading = false;
          this.$bvModal.hide(this.address._id);
          this.$swal({
            title: this.$t("swal.title"),
            text: this.$t("swal.addressUpdated"),
            type: "success",
          });
        })
        .catch((err) => {
          this.isLoading = false;
          this.$bvModal.hide(this.address._id);
          this.$swal({
            title: this.$t("swal.error"),
            text: err.message || this.$t("swal.addressNotUpdated"),
            type: "error",
          });
        });
    },
  },
  mounted() {
    if (this.address && this.address.contacts) {
      this.phone = this.address.contacts[0]?.value || "";
      this.email = this.address.contacts[1]?.value || "";
    }
  },
};
</script>
<style scoped>
.addAddressBtn {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
.addAddressBtn .btn {
  width: 150px;
  margin-left: 15px;
}
.card-custom-class {
  border: none;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-bottom-color: rgba(0, 0, 0, 0.125);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-radius: 0.25rem;
}
.list-group-modal {
  margin-top: 7px;
  max-height: 540px;
  margin-left: 10px;
  margin-right: 4px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.change-location-text {
  font-style: normal;
  font-weight: 520;
  font-size: 26px;
  line-height: 24px;
  margin-left: 5px;

  color: #2e2e2e;
}
.coupon-input {
  border: 0;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
  outline: 0;
  width: 75%;
}
.text-danger {
  color: var(--primarycolor) !important;
  font-size: 14px;
  vertical-align: 5px;
}
.add-new-address-text {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  color: var(--darkcolor);
  cursor: pointer;
  position: absolute;
  right: 75px;
}
.address-name {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;

  color: #000000;
}
.body-class-modal {
  margin-top: -7px;
}

.address-details-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  color: #2e2e2e;
  margin-left: 37px;
  margin-top: 4px;
}

.my-class {
  background: black;
  color: white;
}
.closemodel {
  position: absolute;
  top: 15px;
  right: 12px;
}

.default-address-class {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #717171;
  margin-left: 10px;
}
@media (max-width: 768px) {
  .addAddressBtn .btn {
    width: 100%;
    margin-left: 0;
    margin-bottom: 15px;
  }
  .addAddressBtn {
    display: block;
  }
}
</style>
